import { location } from "../../data/Fleet/Location";
import { TrailerType } from "../../data/Fleet/TrailerType";

export const orientationFieldConfiguration = [
  {
    name: "company",
    label: "Company",
    type: "select",
    options: [
      { label: "C1 Transportation", value: "C1 Transportation" },
      { label: "Fox C Group", value: "Fox C Group" },
    ],
    validation: {
      required: "Company is required",
    },
  },
  {
    name: "orientationDate",
    label: "Orientation Date",
    type: "date",
    validation: {
      required: "Orientation date is required",
    },
  },
  {
    name: "status",
    label: "Status",
    type: "select",
    options: [
      { label: "SCHEDULED", value: "SCHEDULED" },
      { label: "HIRED", value: "HIRED" },
      { label: "DECLINED", value: "DECLINED" },
      { label: "NO SHOW", value: "NO_SHOW" },
    ],
    validation: {
      required: "Status is required",
    },
  },
  {
    name: "recruiter",
    label: "Recruiter",
    type: "text",
    validation: {
      required: "Recruiter is required",
    },
  },
  {
    name: "division",
    label: "Division",
    type: "text",
    validation: {
      required: "Division is required",
    },
  },
  {
    name: "referral",
    label: "Referral",
    type: "text",
  },
  {
    name: "driverHireType",
    label: "Driver Hire Type",
    type: "select",
    validation: {
      required: "Driver hire type is required",
    },
    options: [
      { label: "New hire", value: "NEW_HIRE" },
      { label: "Re-hire", value: "RE-HIRE" },
      { label: "Switch", value: "SWITCH" },
      { label: "Back from vacation", value: "BACK_FROM_VACATION" },
    ],
  },
  {
    name: "driverFirstName",
    label: "Driver First Name",
    type: "text",
    validation: {
      required: "Driver first name is required",
    },
  },
  {
    name: "driverLastName",
    label: "Driver Last Name",
    type: "text",
    validation: {
      required: "Driver last name is required",
    },
  },
  {
    name: "state",
    label: "State",
    type: "select",
    options: location,
    validation: {
      required: "State is required",
    },
  },
  {
    name: "primaryPhoneNumber",
    label: "Primary Phone Number",
    type: "text",
    validation: {
      required: "Primary phone number is required",
      pattern: {
        value: /^\d+$/,
        message: "Phone number must contain only digits",
      },
    },
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    validation: {
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Enter a valid email address",
      },
    },
  },
  {
    name: "trailerType",
    label: "Trailer Type",
    type: "select",
    options: TrailerType,
    validation: {
      required: "Trailer type is required",
    },
  },
  {
    name: "truckId",
    label: "Truck Unit Number",
    type: "combo",
    dataKey: "availableTrucks",
  },
  {
    name: "trailerId",
    label: "Trailer Unit Number",
    type: "combo",
    dataKey: "availableTrailers",
  },
  {
    name: "pay",
    label: "Pay",
    type: "text",
    validation: {
      required: "Pay is required",
    },
  },
  {
    name: "note",
    label: "Note",
    type: "text",
  },
];

export const orientationInitialValues = {
  company: "",
  orientationDate: "",
  status: "",
  recruiter: "",
  division: "",
  referral: "",
  driverHireType: "",
  driverFirstName: "",
  driverLastName: "",
  state: "",
  primaryPhoneNumber: "",
  email: "",
  trailerType: "",
  truckId: "",
  trailerId: "",
  pay: "",
  note: "",
};
